module.exports = __webpack_public_path__ + "static/media/menu_background.2fd0847e.png";